import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "../CSS/RingkasanAnalitikTK.css";

function RingkasanAnalitikTK() {
  const [selectedFilter, setSelectedFilter] = useState("Tahun");

  const data = [
    { bulan: "Jan", aktif: 30, resiko: 10, putus: 7, sembuh: 5 },
    { bulan: "Feb", aktif: 40, resiko: 20, putus: 9, sembuh: 8 },
    { bulan: "Mar", aktif: 35, resiko: 15, putus: 6, sembuh: 12 },
    { bulan: "Apr", aktif: 50, resiko: 10, putus: 5, sembuh: 20 },
    { bulan: "Mei", aktif: 45, resiko: 18, putus: 4, sembuh: 25 },
    { bulan: "Jun", aktif: 48, resiko: 12, putus: 3, sembuh: 28 },
    { bulan: "Jul", aktif: 40, resiko: 10, putus: 5, sembuh: 30 },
    { bulan: "Agus", aktif: 38, resiko: 8, putus: 7, sembuh: 32 },
    { bulan: "Sep", aktif: 42, resiko: 10, putus: 6, sembuh: 35 },
    { bulan: "Okt", aktif: 50, resiko: 15, putus: 5, sembuh: 40 },
  ];

  return (
    <div className="ringkasan-page">
      <div className="main-content-ringkasan">
        {/* container putih utama */}
        <div className="ringkasan-container">
        
          {/* kartu atas */}
          <div className="top-card-container">
            <div className="top-card yellow">
              <p className="label">Wilayah Kasus Tertinggi</p>
              <h1 className="angka">9</h1>
              <p className="keterangan">Tokyo</p>
            </div>
            <div className="top-card blue">
              <p className="label">Wilayah Kasus Terendah</p>
              <h1 className="angka">1</h1>
              <p className="keterangan">Visby</p>
            </div>
          </div>

          {/* grafik */}
          <div className="chart-container">
            <div className="chart-header">
              <p>Bulan</p>
              <select
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                className="dropdown-filter"
              >
                <option value="Tahun">Tahun</option>
                <option value="Bulan">Bulan</option>
                <option value="Minggu">Minggu</option>
              </select>
            </div>

            <ResponsiveContainer width="95%" height={350}>
              <LineChart data={data} margin={{ top: 20, right: 40, left: 0, bottom: 10 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="bulan" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="aktif" name="Aktif Terapi" stroke="#3B82F6" strokeWidth={2} />
                <Line type="monotone" dataKey="resiko" name="Resiko Putus Obat" stroke="#FACC15" strokeWidth={2} />
                <Line type="monotone" dataKey="putus" name="Putus Obat" stroke="#EF4444" strokeWidth={2} />
                <Line type="monotone" dataKey="sembuh" name="Sembuh" stroke="#22C55E" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* sidebar kanan */}
      <div className="sidebar-kanan-ringkasan">
        <div className="right-card total">
          <p>Total Pasien Terdaftar</p>
          <h1>87</h1>
        </div>
        <div className="right-card aktif">
          <p>Aktif Terapi</p>
          <h1>38</h1>
        </div>
        <div className="right-card selesai">
          <p>Selesai Terapi</p>
          <h1>41</h1>
        </div>
        <div className="right-card putus">
          <p>Putus Obat</p>
          <h1>8</h1>
        </div>
      </div>
    </div>
  );
}

export default RingkasanAnalitikTK;
